// Cloudinary URL builder for product photos. Brand assets live locally.
//
// Reads cloud name from REACT_APP_CLOUDINARY_CLOUD_NAME (set in .env at the
// project root). Default transforms `f_auto,q_auto` give the browser the best
// format (WebP/AVIF) and quality automatically. Pass a width to cap delivery
// size for the use case (thumb, card, hero, etc.).
//
// Cloudinary strips file extensions on upload — `1-1.png` becomes public_id
// `1-1`. URLs work with the extension appended (Cloudinary treats it as a
// format hint).

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

export const PRODUCTS_FOLDER = "tamtam/products";

export const cloudinaryUrl = (filename, folder = PRODUCTS_FOLDER, width) => {
  const transforms = ["f_auto", "q_auto"];
  if (width) transforms.push(`w_${width}`);
  const publicId = `${folder}/${filename.replace(/\.[^.]+$/, "")}`;
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/${transforms.join(",")}/${publicId}`;
};
